<template>
  <div id="landing-plans-page">
    <div class="columns">
      <div class="column">
        <div class="level is-mobile">
          <div class="level-left">
            <h1 class="title has-text-primary">PLANES</h1>
          </div>

          <div class="level-right">
            <b-button
              type="is-primary"
              icon-pack="fas"
              icon-left="plus"
              @click="createPlan"
            >
              Nuevo plan
            </b-button>
          </div>
        </div>
      </div>
    </div>

    <div class="columns">
      <div class="column">
        <LandingPlansTable />
      </div>
    </div>
  </div>
</template>

<script>
import LandingPlansTable from "@/components/LandingPlansTable.vue";

export default {
  name: "LandingPlansPage",

  components: {
    LandingPlansTable,
  },

  methods: {
    createPlan() {
      this.$router.push("/landing-planes/nuevo");
    },
  },
};
</script>

<style lang="scss" scoped>
#landing-plans-page {
  position: relative;
  min-height: 100vh;
  padding: 1.5rem 1rem;
}
</style>